<template>
  <section id="hero">
      <b-modal id="abaco-modal" ok-title="Cerrar" ok-only ok-variant="secondary">
        <abaco-help-video-modal video-slug="i0zqsOd0NEQ"></abaco-help-video-modal>
      </b-modal>

    <div class="row d-sm-none">
      <div class="col-12 text-center">
        <div class="microcreditos-title">
          Microcréditos<br>para aliados
        </div>
      </div>
      <div class="col-12 mt-3 mb-3">
        <div class="microcreditos-body text-center">
        Genera una nueva vida crediticia. Tasas preferenciales para arrendadores de la aplicación de Uber y especiales para aquellos del programa Uber Pro.
        </div>
      </div>
      <div class="col-12 d-block mt-1">
        <div class="microcreditos-image" style="overflow: hidden; padding-top: 50px">
          <img src="@/assets/illustrations/illu-uber-01.svg">
        </div>
      </div>
      <div class="col-12">
        <div style="text-align: center">
          <div class="microcreditos-click-here">
            ¡Haz click aquí!
            <img src="@/assets/arrows/curved-arrow.svg" style="margin-top: 25px;">
          </div>
        </div>
      </div>
      <get-your-credit-button :sold-out="soldOut" :hero="true" :form-url="formUrl"></get-your-credit-button>
      <div class="col-12">
        <div style="text-align: center">
          <div class="already-registered mt-3">
            <span class="ya-estas-inscrito">¿Ya estás inscrito?</span><a href="https://plataforma.abacolatam.com/login" class="entra-aqui underline-green">Entra aquí →</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-none d-sm-inline-flex" style="min-height: 460px; width: auto">
      <div class="col-sm-6 col-lg-5 text-left" style="position: relative">
        <div class="microcreditos-title">
          Microcréditos<br>para aliados
        </div>
        <div class="microcreditos-body mt-5 text-left">
        Genera una nueva vida crediticia.<br>
        Tasas preferenciales para arrendadores de la aplicación de Uber y especiales para aquellos del programa Uber Pro.
        </div>

        <div class="microcreditos-cta-container">
          <div class="microcreditos-click-here">
            ¡Haz click aquí!
            <img src="@/assets/arrows/curved-arrow.svg" style="margin-top: 25px;">
          </div>
          <get-your-credit-button :sold-out="soldOut" :hero="true" :desktop="true" :form-url="formUrl"></get-your-credit-button>
          <div class="already-registered mt-3">
            <span class="ya-estas-inscrito">¿Ya estás inscrito?</span><a href="https://plataforma.abacolatam.com/login" class="entra-aqui underline-green">Entra aquí →</a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-7 text-right">
        <div class="microcreditos-image text-left">
          <img src="@/assets/illustrations/illu-uber-01.svg" class="microcreditos-image-desktop">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import GetYourCreditButton from './partials/GetYourCreditButton'
export default {
  name: 'HeroUber',
  components: {GetYourCreditButton},
  props: {
    formUrl: '',
    soldOut: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      showModal: false
    }
  }
}
</script>

<style>
.microcreditos-title {
  height: 84px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 3em;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 52px;
  /*text-align: center;*/
}
.microcreditos-image {
  display: block;
  right: -20px;
  position: relative;
}
.microcreditos-image > img {
  width: 120%;
  min-width: 640px;
  right: -75px;
  position: relative;
}
.microcreditos-image-desktop {
  left: 0px;
  min-height: 460px;
  width: auto;
}
.microcreditos-body {
  letter-spacing: 0;
  line-height: 28px;
  margin-top: 10px;
  margin-bottom: 5px;
  height: 75px;
  color: #777777;
  font-size: 1.2em;
  font-weight: 500;
}
.already-registered {
  margin-top: 10px;
}
.ya-estas-inscrito {
  opacity: 0.5;
  color: #333333;
  font-size: 1.15rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 34px;
}
.entra-aqui {
  margin-left: 10px;
  height: 21px;
  width: 107px;
  color: #333333;
  font-size: 1.05rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
}
.microcreditos-click-here {
  height: 30px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-size: 1.4rem;
  padding-top: 10px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  width: 100%;
  margin-bottom: 40px
}
.microcreditos-cta-container {
  text-align: left;
  position: absolute;
  bottom: 0px;
}
@media (max-width: 768px) {
  .microcreditos-title {
    font-size: 2.7rem;
    line-height: 42px;
  }
  .microcreditos-body {
    font-size: 1.2rem;
    letter-spacing: 0;
    line-height: 25px;
    padding-left: 10px;
    padding-right: 10px;
    margin-top: 0px;
  }
  .already-registered {
    margin-top: 10px;
    margin-bottom: 100px;
  }
  .microcreditos-image {
    display: block;
    right: unset;
    position: unset;
  }
  .microcreditos-image > img {
    width: 100%;
    min-width: unset;
    right: unset;
    position: unset;
  }
  .microcreditos-cta-container {
    bottom: -50px;
  }
}
@media (min-width: 576px) and (max-width: 768px) {
  .microcreditos-body {
    font-size: 1.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeroUber.vue